import classNames from 'classnames';
import * as React from 'react';
import { t } from '../../localization.js';
import Button from '../Button/Button.js';
import Spinner from '../Spinner/Spinner.js';
import styles from './ErrorLoad.module.scss.js';

var ErrorLoad = function (props) {
    var reloadButton = null;
    if (props.onReloadClick) {
        reloadButton = props.isFetching ? (React.createElement(Spinner, { label: t('Загружаем информацию') })) : (React.createElement(Button, { isFlat: props.isFlat, isSmaller: props.isFlat, onClick: props.onReloadClick }, props.buttonTitle ? props.buttonTitle : t('Обновить')));
    }
    return (React.createElement("div", { className: classNames(styles.container, props.className) },
        React.createElement("div", null,
            React.createElement("span", { className: styles.message }, props.message)),
        reloadButton));
};
var ErrorLoad$1 = React.memo(ErrorLoad);

export { ErrorLoad$1 as default };
//# sourceMappingURL=ErrorLoad.js.map
